/**
 * Internal dependencies
 */
import { useGetBuyersQuery } from '@/api';
import useFilterOptions from '../useFilterOptions';

const useBuyersFilterOptions = () => useFilterOptions(useGetBuyersQuery().data);

export default useBuyersFilterOptions;
